import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { usuarioActions } from '../../../application/actions/usuario';

import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);


// Usuario
export function* usuarioBuscar(e) {
    yield put(usuarioActions.conexionUsuario({conexion:false}));
    try {
        const  params  = e.payload;
        const url = `usuario/${params.rut}`
        const response = yield call(
            apiRequest.get,
            url,
            null,
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(usuarioActions.craerUsuario({usuario: data}));
    } catch (err) {
        yield put(usuarioActions.conexionUsuario({conexion:false}));
        yield put(usuarioActions.errorUsuario({error:err.message}));
    } finally {
    }
}


export function* usuarioRegistrar(e) {
    yield put(usuarioActions.conexionUsuario({conexion:false}));
    try {
        const  params  = e.payload;
        const url = `usuario/crear`
        const response = yield call(
            apiRequest.post,
            url,
            params,
        );

        // Extraigo todos los datos
        const  data  = response;
        console.log(data)
        const registro = {
            dataUsuarioRegistrado:data.result,
            dataUsuarioRegistradomensaje:data.message
        }
        yield put(usuarioActions.registrarUsuario(registro));
    } catch (err) {
        yield put(usuarioActions.conexionUsuario({conexion:false}));
        yield put(usuarioActions.errorUsuario({error:err.message}));
    } finally {
    }
}


export function* watchFetchUsuario() {
    yield takeLatest(usuarioActionsSaga.activeUsuario.type, usuarioBuscar);
    yield takeLatest(usuarioActionsSaga.activeUsuarioRegistrar.type, usuarioRegistrar);
}

export default function* rootSaga() {
    yield spawn(watchFetchUsuario);
}


const activeUsuario = createAction('usuarioSaga/activeUsuario');
const activeUsuarioRegistrar = createAction('usuarioSaga/activeUsuarioRegistrar');

export const usuarioActionsSaga = {
    activeUsuario,
    activeUsuarioRegistrar,
};
